import history from './history'

export const unAuthorizedRedirect = () => {
  history.push('/login')
}
